import { GridValueFormatterParams } from '@mui/x-data-grid';
import { toTitleCase } from 'helpers/strings';
import { DeviceStatusSummary } from 'types';

export const statusChipToTextFormatter = (
    params: GridValueFormatterParams<DeviceStatusSummary[]>
) => {
    if (!params.value) return '';
    else {
        let statusText = '';
        params.value.forEach((status: DeviceStatusSummary, i: number) => {
            const numOfStatusesShown = params.value.filter(
                (status) => status.isCustomerFacing
            ).length;

            if (status.isCustomerFacing) {
                statusText += `${toTitleCase(status.status)} (${status.count})`;
                // Don't put a comma after the last entry.
                if (i < numOfStatusesShown - 1) statusText += ', ';
            }
        });
        return statusText;
    }
};
